/** Tabs showcase data — from sf-react-app */
import React from 'react';
import { FireIcon } from '../../../design-system/components/Icons';

const TAB_FIGMA_WITH_ICONS = [
  { value: 'me', label: 'Me', icon: <FireIcon /> },
  { value: 'team', label: 'Team', icon: <FireIcon />, badge: 2 },
  { value: 'unassigned', label: 'Unassigned', icon: <FireIcon /> },
  { value: 'all', label: 'All' },
];

const TAB_FIGMA_TEXT_ONLY = [
  { value: 'me', label: 'Me' },
  { value: 'team', label: 'Team', badge: 2 },
  { value: 'unassigned', label: 'Unassigned' },
  { value: 'all', label: 'All' },
];

export { TAB_FIGMA_WITH_ICONS, TAB_FIGMA_TEXT_ONLY };